var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_Bin_24x24",
    "data-name": "Icon Bin 24x24",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "invisible_box",
    "data-name": "invisible box"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_35914",
    "data-name": "Rectangle 35914",
    width: 24,
    height: 24,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_43523",
    "data-name": "Group 43523",
    transform: "translate(4.048 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_370491",
    "data-name": "Path 370491",
    d: "M22.9,6.075a1.219,1.219,0,0,1-.318.848.9.9,0,0,1-.742.318h-5.3a1.06,1.06,0,0,1-1.06-1.06V5.12h-1.06v1.06a1.06,1.06,0,0,1-1.06,1.06H8.113A1.113,1.113,0,0,1,7,6.287a1.219,1.219,0,0,1,.318-.848A.9.9,0,0,1,8.06,5.12H12.3V4.06A1.06,1.06,0,0,1,13.361,3h3.181A1.06,1.06,0,0,1,17.6,4.06V5.12H21.79A1.113,1.113,0,0,1,22.9,6.075Z",
    transform: "translate(-6.999 -3)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_370492",
    "data-name": "Path 370492",
    d: "M21.995,14.9l-.2,13.1h-10.4l-.2-13.1a1,1,0,0,0-1-.9h0a1,1,0,0,0-1,1.1l.3,14a1,1,0,0,0,1,.9h12.2a1,1,0,0,0,1-.9l.3-14a1,1,0,0,0-1-1.1h0A1,1,0,0,0,21.995,14.9Z",
    transform: "translate(-8.642 -8.76)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_371533",
    "data-name": "Path 371533",
    d: "M11,1a1,1,0,0,0-1-1H1A1,1,0,0,0,1,2h9A1,1,0,0,0,11,1Z",
    transform: "translate(6.952 17.74) rotate(-90)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_371534",
    "data-name": "Path 371534",
    d: "M11,1a1,1,0,0,0-1-1H1A1,1,0,0,0,1,2h9A1,1,0,0,0,11,1Z",
    transform: "translate(3.952 17.74) rotate(-90)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_371535",
    "data-name": "Path 371535",
    d: "M11,1a1,1,0,0,0-1-1H1A1,1,0,0,0,1,2h9A1,1,0,0,0,11,1Z",
    transform: "translate(9.952 17.74) rotate(-90)",
    fill: "#1d1d1b"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBin);
export default __webpack_public_path__ + "static/media/icon-bin.8975d0070421bc208acb41ac9f915ca0.svg";
export { ForwardRef as ReactComponent };